module.exports = __webpack_public_path__ + "static/media/LTC.a7154ecc.svg";